/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import Form from 'forms/_.extend';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
  form: Form,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class EnableAccountForm extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { form }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:trading_accounts.reasons.why_enable_multiple')}
          >
            <div className={styles['form-group']}>
              <ElectroTextField
                field={form.$('enableAccountForm.reason')}
                props={{
                  multiline: true,
                  rows: 3,
                }}
              />
            </div>
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons
          form={form}
          submitTxt={t('general:actions.enable_account_plural')}
        />
      </React.Fragment>
    );
  }
}
